import React, { useRef } from "react";
import Icon from "../Icon";
import _Button from "../generic/_Button";
import PropTypes from "prop-types";

const ImageUpload = (orops) => {
  const { previewUrl, setPreviewUrl, setFile } = orops;
  const fileInputRef = useRef(null);
  const handleFile = (event) => {
    const file = event.target.files?.[0];

    if (file && file.type.startsWith("image/")) {
      setFile(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewUrl(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <div>
      {!previewUrl ? (
        <>
          <div className="flex flex-col items-center justify-center rounded-lg border-2 border-gray-300 border-dashed border-border p-8 text-center">
            <div className="flex justify-center gap-2">
              <Icon icon="add_photo_alternate" />
              <div className="mb-2 text-sm text-muted-foreground text-gray-600">
                Selecciona una imagen para subir
              </div>
            </div>
            <input
              ref={fileInputRef}
              type="file"
              accept="image/*"
              onChange={handleFile}
              className="hidden"
            />
          </div>
          <div className="flex justify-end mt-2">
            <_Button
              title="Subir imagen"
              icon="upload"
              style="none"
              onClick={() => fileInputRef.current.click()}
            />
          </div>
        </>
      ) : (
        <div className="relative rounded-lg border border-border p-4">
          <img
            src={previewUrl}
            alt="Preview"
            className="h-auto w-full rounded-md object-contain"
            style={{ maxHeight: "300px" }}
          />
          <button
            onClick={() => {
              setPreviewUrl(null);
            }}
            className="absolute top-2 right-2 rounded-full bg-black-50 hover:bg-black  hover:text-white border-none flex items-center p-2"
          >
            <Icon icon="close" className={"hover:text-white"} />
          </button>
        </div>
      )}
    </div>
  );
};

ImageUpload.propTypes = {
  previewUrl: PropTypes.string,
  setPreviewUrl: PropTypes.func,
  setFile: PropTypes.func,
};

export default ImageUpload;
